import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import UIOverlayContent from 'UIComponents/overlay/UIOverlayContent';
import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import { withTransientStyleProps } from 'automation-ui-core/components/TransientStylePropsDecorator';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIOverlay = styled(withTransientStyleProps(UIOverlay)).withConfig({
  displayName: "TestFlowContent__StyledUIOverlay",
  componentId: "sc-1snsrit-0"
})(["top:", "px !important;display:flex;justify-content:center !important;align-items:flex-start;"], props => props.$canvasTopOffset);
const TestFlowContent = ({
  viewData,
  flow,
  Canvas,
  canvasScrollElementRef
}) => {
  const canvasTopOffset = useCanvasTopOffset(canvasScrollElementRef);
  const {
    actionCardPropsById,
    recordId,
    isLoading,
    setActiveActionId
  } = viewData;
  const shouldShowOverlay = !recordId || isLoading;
  const overlayContent = isLoading && /*#__PURE__*/_jsx(UIOverlayContent, {
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      showLabel: true
    })
  });
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "TEST_FLOW",
    children: [shouldShowOverlay && /*#__PURE__*/_jsx(StyledUIOverlay, {
      use: "dark",
      width: "100%",
      $canvasTopOffset: canvasTopOffset,
      centerContent: false,
      children: overlayContent
    }), /*#__PURE__*/_jsx(Canvas, {
      flow: flow,
      actionCardPropsById: actionCardPropsById,
      onSelectAction: actionId => {
        setActiveActionId(actionId);
      }
    })]
  });
};
export default TestFlowContent;